import { render } from "./EditContactModal.vue?vue&type=template&id=ba845fca&scoped=true"
import script from "./EditContactModal.vue?vue&type=script&lang=js"
export * from "./EditContactModal.vue?vue&type=script&lang=js"

import "./EditContactModal.vue?vue&type=style&index=0&id=ba845fca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba845fca"]])

export default __exports__